<template>
  <section
    id="hero"
    class="hero-section"
  >
    <div class="container">
      <div class="title-wrapper">
        <span class="description">SUCCESS STORIES</span>
        <h1 class="title">{{ summary }}</h1>
        <p class="position">{{ name }} - {{ position }}</p>
        <ApplyButton
          cta-section="hero"
          page-name="story-page"
          class="proxify-btn proxify-btn-white"
        />
      </div>
      <div class="image-wrapper">
        <div class="image-cover">
          <NuxtImg
            src="/images/story-page/line.svg"
            class="line"
            alt="hero"
            lazy
          />
          <img
            :src="image"
            class="hero-image"
            alt="hero"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: { ApplyButton },
  props: {
    summary: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
